export default __webpack_public_path__ + "assets/images/37c072bd5846ef9d4dadda3170b53540.svg";